import api from "./api";

export const getNotifications = async () => {
  const res = await api.get("/notifications");
  return res.data;
};

export const sendNotification = async (payload) => {
  const res = await api.post("/notifications/send", payload);
  return res.data;
};
